import React, { lazy, Suspense, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import axios from "../../axios";
import NotFound from "../../pages/NotFound";
import * as actions from "../../store/actions";
import AuthenticatedRoute from "../AuthenticatedRoute";
import Banners from "../Banner/Banners";
import Footer from "../Footer/Footer";
import Menu from "../Header/Header";
import withErrorHandler from "../hoc/withErrorHandler";
import Loading from "../Loading/DataLoading";
import SidebarNavigation from "../Sidebar/SidebarNavigation";
import styles from "./Layout.module.scss";
import OpeningHoursConfirmationModal from "../OpeningHours/OpeningHours";

const Registration = lazy(() =>
  import("../../pages/angel/Registration/Registration")
);
const NewProperty = lazy(() =>
  import("../../pages/angel/NewProperty/NewProperty")
);

const Dashboard = lazy(() => import("../../pages/angel/Dashboard"));
const DashboardAffiliate = lazy(() =>
  import("../../pages/affiliate/Dashboard")
);
const Revenue = lazy(() => import("../../pages/angel/Revenue/Revenue"));
const Orders = lazy(() => import("../../pages/angel/Orders/Orders"));
const LinkPage = lazy(() => import("../../pages/affiliate/LinksPage/LinkPage"));
const MarketingCollateral = lazy(() =>
  import("../../pages/affiliate/MarketingCollateral/MarketingCollateral")
);
const Integrations = lazy(() =>
  import("../../pages/affiliate/Integrations/Integrations")
);
const Commission = lazy(() => import("../../pages/affiliate/Commission"));
const Programs = lazy(() => import("../../pages/affiliate/Programs"));
const Settings = lazy(() => import("../../pages/Settings/Settings"));
const Password = lazy(() => import("../../pages/SetPassword/Password"));
const Company = lazy(() => import("../../pages/angel/Company/Company"));
const Payment = lazy(() => import("../../pages/angel/Payment/Payment"));
const OnboardingModal = lazy(() =>
  import("../OnboardingModal/OnboardingModal")
);
const DisabledOrganizationModal = lazy(() =>
  import("../OrganizationModal/DisabledOrganizationModal")
);
const AngelAppCalendar = lazy(() =>
  import("../../pages/angel/External/AngelAppCalendar")
);
const OpeningHoursPage = lazy(() =>
  import("../../pages/angel/OpeningHours/OpeningHoursPage")
);

const MyAccountRedirect = () => {
  useEffect(() => window.location.replace("/my/account"), []);
  return null;
};

const loadingWrapStyles = {
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "center",
  minHeight: "70vh",
};
const Layout = (props) => {
  const dispatch = useDispatch();
  // const deviceType = useDeviceType();
  // //console.log(deviceType);
  const tokenInfo = useSelector((state) => state.auth.info);
  const { status, id } = useSelector((state) => state.organization);
  const { isAffiliate, isAngel, angelStoragesCount } = tokenInfo;
  const [isAuthenticated, setAuthenticated] = useState(null);
  const [isBanner, setIsBanner] = useState(true);
  const [menuHeight, setMenuHeight] = useState(0);
  const [bannerHeight, setBannerHeight] = useState(0);
  const [isOrganizationEnabled, setIsOrganizationEnabled] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const [cookies] = useCookies(["TOKEN"]);

  const [showSideNav, setShowSideNav] = useState(true);
  const isStandalonePage = window.location.pathname.includes("/angel/opening-hours");

  useEffect(() => {
    console.log(tokenInfo, "tokenInfo");
    if (cookies.TOKEN) {
      setAuthenticated(true);
      dispatch(actions.setUserInfo(cookies.TOKEN));
      axios.defaults.headers.common["X-TOKEN"] = cookies.TOKEN;
    } else {
      setAuthenticated(false);
      setShowSideNav(false);
    }
    // eslint-disable-next-line
  }, [cookies, dispatch]);
  useEffect(() => {
    setIsBanner(isAngel && isAffiliate === false);

    if (
      typeof angelStoragesCount !== "undefined" &&
      angelStoragesCount === 0 &&
      !isAffiliate
    ) {
      //will open step 2
      setShowSideNav(false);
    } else if (angelStoragesCount > 0) {
      setShowSideNav(true);
    }
  }, [angelStoragesCount, isAffiliate, isAngel, tokenInfo]);

  useEffect(() => {
    id && status && setIsOrganizationEnabled(status === "enabled");
  }, [status, id]);

  useEffect(() => {
    setIsShowModal(
      isAuthenticated === true &&
        isAngel &&
        isAffiliate === false &&
        isOrganizationEnabled === false
    );
  }, [isAuthenticated, tokenInfo, isOrganizationEnabled, isAngel, isAffiliate]);

  let routs = null;

  let angelRoutes = [
    <AuthenticatedRoute
      key={"angel-dashboard"}
      path="/:lang?/angel/dashboard"
      exact
      component={Dashboard}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-orders"}
      path="/:lang?/angel/luggage-storage/orders"
      exact
      component={Orders}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-revenue"}
      path="/:lang?/angel/luggage-storage/revenue"
      exact
      component={Revenue}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-company"}
      path="/:lang?/angel/company"
      exact
      component={Company}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-profile"}
      path="/:lang?/angel/profile"
      exact
      component={Settings}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-luggage-storage"}
      path="/:lang?/angel/luggage-storage"
      exact
      component={AngelAppCalendar}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"angel-payment"}
      path="/:lang?/angel/payment"
      exact
      component={Payment}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"new-property"}
      path="/:lang?/angel/new-property"
      exact
      component={NewProperty}
      isAuthenticated={isAuthenticated}
    />,
  ];

  let affiliateRoutes = [
    <AuthenticatedRoute
      key={"affiliates-dashboard"}
      path="/:lang?/affiliates/dashboard"
      exact
      component={DashboardAffiliate}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-commission"}
      path="/:lang?/affiliates/dashboard/commission"
      exact
      component={Commission}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-programs"}
      path="/:lang?/affiliates/dashboard/programs"
      exact
      component={Programs}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-links"}
      path="/:lang?/affiliates/dashboard/links"
      exact
      component={LinkPage}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-marketing"}
      path="/:lang?/affiliates/dashboard/marketing_collateral"
      exact
      component={MarketingCollateral}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-integrations"}
      path="/:lang?/affiliates/dashboard/integrations"
      exact
      component={Integrations}
      isAuthenticated={isAuthenticated}
    />,
    <AuthenticatedRoute
      key={"affiliates-profile"}
      path="/:lang?/affiliates/profile"
      exact
      component={Settings}
      isAuthenticated={isAuthenticated}
    />,
  ];

  if (
    isAuthenticated === true &&
    isAffiliate === false &&
    !!isAngel &&
    isOrganizationEnabled
  ) {
    routs = (
      <Switch>
        {angelRoutes}
        <Route path="/:lang?/angel">
          <Redirect to="/angel/luggage-storage" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }

  if (
    isAuthenticated === true &&
    !!isAngel &&
    !!isAffiliate &&
    isOrganizationEnabled
  ) {
    routs = (
      <Switch>
        {angelRoutes}

        {affiliateRoutes}

        <Route path="/:lang?/affiliates">
          <Redirect to="/affiliates/dashboard" />
        </Route>
        <Route path="/:lang?/angel">
          <Redirect to="/angel/luggage-storage" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }

  if (
    isAuthenticated === true &&
    !!isAngel &&
    !!isAffiliate &&
    !isOrganizationEnabled
  ) {
    routs = (
      <Switch>
        {affiliateRoutes}
        <Route path="/:lang?/affiliates">
          <Redirect to="/affiliates/dashboard" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }

  if (isAuthenticated === true && !isAngel && !!isAffiliate) {
    routs = (
      <Switch>
        {affiliateRoutes}
        <Route path="/:lang?/affiliates">
          <Redirect to="/affiliates/dashboard" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }

  if (isAuthenticated === false) {
    routs = (
      <AuthenticatedRoute path={`/`} isAuthenticated={false}>
        {/*<Redirect to={"/?login=" + window.location.pathname}/>*/}
      </AuthenticatedRoute>
    );
  }

  if (isAuthenticated === true && isAffiliate === false && !isAngel) {
    routs = <Redirect to={"/my/account"} />;
  }

  return (
    <Router>
      <div
        className={styles.layout}
        style={{ paddingTop: isBanner ? bannerHeight : 0 }}
      >
        {!isStandalonePage && isAuthenticated && cookies.TOKEN && <OpeningHoursConfirmationModal />}

        {!isStandalonePage && (
          <Banners
            setBannerHeight={setBannerHeight}
            style={{ display: isBanner ? "block" : "none" }}
          />
        )}

        {!isStandalonePage && (
          <Menu
            setMenuHeight={setMenuHeight}
            setAuthenticated={setAuthenticated}
            style={{ top: isBanner ? bannerHeight : 0 }}
            hideSideNav={!showSideNav}
          />
        )}

        {!isStandalonePage && showSideNav && (
          <SidebarNavigation
            isAffiliate={isAffiliate}
            style={{ top: isBanner ? bannerHeight + menuHeight : menuHeight }}
          />
        )}
        <main className={""} style={!showSideNav ? { marginLeft: 0 } : {}}>
          <Suspense
            fallback={
              <div style={loadingWrapStyles}>
                <Loading />
              </div>
            }
          >
            <Switch>
              <Route path="/:lang?/affiliates/password" component={Password} />
              <Route path="/:lang?/angel/password" component={Password} />
              <Route
                path="/:lang?/angel/registration"
                component={Registration}
              />
              <AuthenticatedRoute
                path="/:lang?/angel/opening-hours"
                isAuthenticated={isAuthenticated}
                component={
                  !!isAngel || !!isAffiliate || !!window.ReactNativeWebView
                    ? OpeningHoursPage
                    : () => <Redirect to="/my/account" />
                }
              />

              <Route path="/:lang?/my/account" component={MyAccountRedirect} />

              {routs}
            </Switch>
          </Suspense>
          {!!isAngel && <OnboardingModal />}
        </main>

        {!isStandalonePage && <Footer />}

        {isShowModal ? <DisabledOrganizationModal /> : <></>}
      </div>
    </Router>
  );
};

export default withErrorHandler(Layout);
